import properties from '../engine/properties';

export default async function delay() {
  await new Promise((res) => setTimeout(res, properties.repaintMs));
}
